<template>
  <div>
    <div
      class="pricing-block"
      v-for="{ name, items } in featuresList"
      :key="name"
    >
      <VText class="pricing-block__title" variant="h4" component="h3">{{
        name
      }}</VText>
      <ul class="pricing-block__list">
        <li
          class="pricing-block__item"
          v-for="({ name, description, to, href, supported }, i) in items"
          :key="`${name}${i}`"
        >
          <PricingTableItem :description="description" :to="to" :href="href">
            {{ name }}
          </PricingTableItem>
          <div class="pricing-block__item__icons">
            <PricingTableIcon
              v-for="i in 5"
              :key="i"
              :supported="supported"
              :index="i - 1"
              :title="TITLES[i - 1]"
              variant="circle"
            />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { computed, ref } from '@nuxtjs/composition-api';
import { useTheme, VText } from '@campsite-bio/component-lib';
import tinycolor from 'tinycolor2';

import PricingTableItem from './pricing-table-item';
import PricingTableIcon from './pricing-table-icon';
import featuresList from './features-list.json';

const TITLES = ['Pro+', 'Pro', 'Org Pro+', 'Org Pro', 'Free'];

export default {
  components: {
    PricingTableIcon,
    PricingTableItem,
    VText,
  },

  setup() {
    const theme = useTheme();
    const root = ref(null);

    const styles = computed(() => {
      return {
        '--c-pro-color': tinycolor(theme.value.colors.primary)
          .setAlpha(0.1)
          .toRgbString(),
      };
    });

    return {
      root,
      featuresList,
      styles,
      TITLES,
    };
  },
};
</script>

<style lang="scss" scoped>
.pricing-block__title.pricing-block__title {
  margin-bottom: 0.75rem;
}

.pricing-block {
  margin-bottom: 1.75rem;
  text-align: left;

  &__list {
    background: #fff;
    border-radius: var(--g-border-radius-standard);
    border-radius: Min(
      var(--g-border-radius-standard),
      var(--g-border-radius-min)
    );
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__item {
    border-top: 1px solid var(--g-color-gray-200);
    padding: 0.75rem 1rem;

    &:first-child {
      border-top: none;
    }

    &__icons {
      display: flex;
      justify-content: space-between;
      text-align: center;
      margin-top: 0.75rem;
      gap: 0.25rem;
    }
  }
}
</style>
